export const url = {
  baseApiUrl: 'https://api-dev.iregisterkids.com/api/',
  screen_app: 'https://screen-dev.iregisterkids.com',
  kiosk: 'https://iregisterkids.com/api/updates/kiosk/kiosk.exe',
  apk: 'https://play.google.com/store/apps/details?id=com.igeeksng.iregisterkidstab'
};

export default url.baseApiUrl;